import { css } from "lit";

export const style = css`
	:host {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}

	rp-fsection:first-child {
		border-top: 1px solid var(--og-bucket-border-color);
	}
`;
